import { Col, Container, Row } from "react-bootstrap";
import ImageTitleDescVert from "../../image/imageTitleDescVert";
import "../../../assets/css/scss/section/player/_profileStatisticsRecentStories.scss";
import { RECENT_STORIES } from "../../../constant/match";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../../interfaces/redux";
import GetAdvertisementElement from "../../../common/getAdvertisementElement";
import { useEffect, useState } from "react";
import GetActiveDealAdvertisement from "../../../common/getActiveDealAdvertisement";

export default function ProfileStatisticsRecentStories(props: any) {
  const [leftAdvertisement, setLeftAdvertisement] = useState({});
  const [rightAdvertisement, setRightAdvertisement] = useState({});
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  const globalActiveAdv = useSelector(
    (state: IReduxStateData) => state.activeDealAdvertisement
  );
  useEffect(() => {
    if (globalActiveAdv) {
      const advertisementLeftForPage = GetActiveDealAdvertisement(
        globalState,
        2,
        props?.isTeam ? 2 : 3
      );
      setLeftAdvertisement(advertisementLeftForPage || {});
      const advertisementRightForPage = GetActiveDealAdvertisement(
        globalState,
        3,
        props?.isTeam ? 2 : 3
      );
      setRightAdvertisement(advertisementRightForPage || {});
    }
  }, [globalActiveAdv]);
  return (
    <section className="recent-stories">
      <Container className="theme-light-white">
        <div className="row title">
          <div className="col-12">
            <h3 className="bold theme-dark-black mb-0">
              {RECENT_STORIES[selectedLang]["title"]}
            </h3>
          </div>
        </div>
        <Row>
          <Col md={2} xl={2}>
            {Object.keys(leftAdvertisement).length ? (
              <div
                className="advertisement-wrapper adv-image mb-3 mt-3"
                style={{ height: "400px", width: "100%" }}
              >
                <GetAdvertisementElement {...leftAdvertisement} />
              </div>
            ) : null}
          </Col>
          <Col md={8} xl={8}>
            <ImageTitleDescVert {...props} />
          </Col>
          <Col md={2} xl={2}>
            {Object.keys(rightAdvertisement).length ? (
              <div
                className="advertisement-wrapper adv-image mb-3 mt-3"
                style={{ height: "400px", width: "100%" }}
              >
                <GetAdvertisementElement {...rightAdvertisement} />
              </div>
            ) : null}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
